const initHistoryTimeline = () => {
  const timeline = document.querySelector('.home-history-timeline');
  if (!timeline) return;

  const items = timeline.querySelectorAll('[data-accordion-item]');

  items.forEach((item) => {
    const trigger = item.querySelector('.home-history-period-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');

      items.forEach((other) => {
        if (other !== item && other.classList.contains('is-active')) {
          other.classList.remove('is-active');
          const otherTrigger = other.querySelector('.home-history-period-trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.toggle('is-active', !isActive);
      trigger.setAttribute('aria-expanded', String(!isActive));
    });
  });
};

export default initHistoryTimeline;
